import * as React from 'react';
import { Platform } from 'react-native';
import { BodyMediumRegular, View, XStack, type XStackProps } from 'smoothie';

import GoalCategoryIcon from '../../../goals/components/summary/GoalCategoryIcon';
import GoalProgress from '../../../goals/components/summary/GoalProgress';
import {
    GoalCardContext,
    type GoalCategoryDescription,
    GoalStatus,
} from '../../../goals/types/Goal';

interface DummyGoalCardProps extends XStackProps {
    goalDescription: string;
    goalCategoryDescription: GoalCategoryDescription;
    completedTaskCount: number;
    totalTaskCount: number;
}

export const DummyGoalCard = ({
    goalDescription,
    goalCategoryDescription,
    completedTaskCount,
    totalTaskCount,
    ...props
}: DummyGoalCardProps) => {
    const shadowStyle = Platform.select({
        ios: {
            shadowColor: 'rgba(0, 0, 0, 0.05)',
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowOpacity: 0.03,
            shadowRadius: 10,
        },
        android: {
            elevation: 5,
        },
    });

    return (
        <XStack
            width="100%"
            height={80}
            padding={10}
            backgroundColor="$white"
            borderWidth={1}
            borderColor="$gray200"
            borderRadius={16}
            gap={8}
            alignItems="center"
            style={{ ...shadowStyle }}
            {...props}
        >
            <GoalCategoryIcon
                goalCategoryDescription={goalCategoryDescription}
            />

            <View flex={1}>
                <BodyMediumRegular numberOfLines={2}>
                    {goalDescription}
                </BodyMediumRegular>
            </View>

            <View marginLeft="auto" alignSelf="flex-start">
                <GoalProgress
                    totalTaskCount={totalTaskCount}
                    completedTaskCount={completedTaskCount}
                    status={GoalStatus.IN_PROGRESS}
                    context={GoalCardContext.HOME}
                />
            </View>
        </XStack>
    );
};

export default DummyGoalCard;
